import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ZkIOption } from '@zenklub/ng-ui/component/input/dropdown/dropdown.interface';
import { LocationService } from 'app/services/location.service';
import { isValidCPF } from 'app/shared/validations/valid-cpf.validator';
import { IContact } from 'shared/interfaces/contact.interface';

@Component({
	selector: 'vc-userform',
	templateUrl: './vc-userform.component.html',
	styleUrls: ['./vc-userform.component.scss'],
})
export class VCUserForm implements OnInit {
	genders: ZkIOption[];
	states: ZkIOption[];
	yearRange: string;
	formData: IContact;
	formStatus = {
		default: 'default',
		fiscalId: 'default',
		displayName: 'default',
	};

	@Output('cancel')
	emCancel = new EventEmitter<MouseEvent>();

	@Output('dataUpdate')
	emDataUpdate = new EventEmitter<IContact>();

	@Input()
	contactData: IContact;

	@Input()
	loading: boolean;

	constructor(
		private translateService: TranslateService,
		private locationService: LocationService
	) {}

	ngOnInit(): void {
		this.formData = Object.assign({}, this.contactData);

		this.getGenders();
		this.getStates();
		this.checkFields();
	}

	checkFields(): void {
		const fiscalId = this.formData?.fiscalId;
		const displayName = this.formData?.displayName || '';

		this.formStatus.fiscalId = 'empty';
		if (fiscalId) {
			this.formStatus.fiscalId = isValidCPF(fiscalId) ? 'default' : 'error';
		}

		this.formStatus.displayName = displayName.replace(/([^A-Za-z])/g, '')
			? 'default'
			: 'error';
	}

	private getStates() {
		this.states = [];
		this.locationService.getCountryRegions(1).subscribe((res) => {
			this.states = res.map(({ code, name }) => ({ label: code, value: name }));
		});
	}

	private getGenders() {
		const translatePath = 'MY_ACCOUNT.PERSONAL.GENDER_OPTIONS';
		this.genders = [];

		this.translateService
			.get([translatePath])
			.subscribe(({ [translatePath]: optionsObj }) => {
				for (const property in optionsObj) {
					this.genders.push(optionsObj[property]);
				}
			});
	}

	handleCancel() {
		this.emCancel.emit();
	}

	handleUpdate() {
		this.checkFields();
		if (Object.values(this.formStatus).every((field) => field === 'default')) {
			this.emDataUpdate.emit(this.formData);
		}
	}
}
